export enum VerifiedStatus {
  Created,
  Submitted,
  Verified,
}
export enum SetPinLimitStep {
  SetLimit,
  SetNewPin,
  SetConfirmPin,
}
export enum ChangePinStep {
  SetCurrentPin,
  SetNewPin,
  SetConfirmPin,
}
export enum SetPinType {
  AskPin,
  CurrentPin,
  NewPin,
  ConfirmPin,
  UpdateLimit,
}
export enum UserTransactionStatus {
  Waiting,
  Paid,
  Cancelled,
  Failed,
}
export enum UserTransactionFilter {
  All,
  Cancelled,
  Waiting,
  Success,
  Expired,
}
export class LoginRequest {
  public username: string;
  public password: string;
  public ApprovalConsent: boolean;
  public device: string;
}

export class DeviceInfo {
  public deviceType: string;
  public webType: string;
  public os: string;
}

export class ResetPasswordRequest {
  id: string;
  unique_id: string;
  email: string;
  new_password: string;
}
export class ChangePasswordRequest {
  current_password: string;
  new_password: string;
}
export class ChangePinRequest {
  current_pin: string;
  new_pin: string;
}
export class ActivationRequest {
  Phone: string;
  Email: string;
  IdentityCardFile: File;
}
export class AccountStatus {
  is_verified: boolean;
  verified_status: VerifiedStatus;
  already_set_pin: boolean;
  already_set_limit: boolean;
  is_email_verified: boolean;
}
export class ChangeLimitRequest {
  isOn: boolean;
  limit: number;
  pin: string;
}
export class SetPinLimitRequest extends ChangeLimitRequest {
  pin: string;
}
export class Limit {
  public isOn: boolean;
  public limit: number;
  public pin: string;
}
export class RegisterCompanyRequest {
  public business_type_code: string;
  public business_name: string;
  public province_id: string;
  public regency_id: string;
  public district_id: string;
  public village_id: string;
  public postal_code: string;
  public coordinate: string;
  public image: File;
  public image_name: string;
  public business_address: string;
  public neighbourhood: string;
  public hamlet: string;
}
export class RegisterUserRequest {
  public is_same_address: boolean;
  public email: string;
  public phone_number: string;
  public name: string;
  public ktp_number: string;
  public ktp_file: File;
  public ktp_file_name: string;
  public province_id: string;
  public regency_id: string;
  public district_id: string;
  public village_id: string;
  public postal_code: string;
  public coordinate: string;
  public delivery_address: string;
  public neighbourhood: string;
  public hamlet: string;
  public warehouse_license_file: File;
  public warehouse_license_file_name: string;
}
export class RegisterTaxpayerRequest {
  public has_npwp: boolean;
  public npwp_number: string;
  public name: string;
  public address: string;
  public is_non_pkp: boolean;
  public file: File;
  public file_name: string;
  public sppkp_file: File;
  public sppkp_file_name: string;
  public aggreement: boolean;
  public statement_file: File;
  public statement_file_name: string;
}
